import pointApi from "@/apis/liff/v2/point";
import preorderApi from "@/apis/liff/v2/preorder";
import _ from "lodash";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    cart: {}, // key: sku id, value: quantity
    skus: [],
    cachedSkus: {},
    categories: [],
    configuration: null,
    memberPoints: 0,
    ongoingPreorderCount: 0,
  },
  getters: {
    totalQuantity({ cart }) {
      return _.chain(cart).values().sum().value();
    },
  },
  actions: {
    async fetchConfiguration(context, preorderSettingId) {
      const response = await preorderApi.fetchConfiguration(preorderSettingId)
      context.state.configuration = _.get(response, "data.data", []);
      context.state.ongoingPreorderCount = _.get(response, "data.ongoing_preorder_count", 0);
    },
    async fetchSkus(context, query) {
      const response = await preorderApi.fetchSkus(query)
      context.state.skus = _.get(response, "data.data", []);
      context.state.categories = _.get(response, "data.categories", []);

      context.state.skus.map(sku => {
        context.state.cachedSkus[sku.id] = sku
      })

      return response
    },
    async fetchMemberPoints(context) {
      context.state.memberPoints = _.get(await pointApi.getAvailablePoints(null), 'point', 0)
    },
    updateCartQuantity(context, { skuId, quantity }) {
      if (quantity === 0) {
        Vue.delete(context.state.cart, skuId);
      } else {
        Vue.set(context.state.cart, skuId, quantity);
      }
    },
    clearCart(context) {
      Object.keys(context.state.cart).forEach(skuId => {
        Vue.delete(context.state.cart, skuId);
      });
    },
  },
};
